/**
 * VerdictSlice — final synthesised council output (executive summary + dissent + plan).
 * Invariants: verdict is set exactly once per session; clearVerdict resets the slot.
 */
import type { StateCreator } from "zustand";
import type { Verdict } from "../../domain/types";
import type { DebateStore } from "../debateStore";

export interface VerdictSlice {
  verdict: Verdict | null;
  setVerdict(v: Verdict): void;
  clearVerdict(): void;
}

export type VerdictSliceCreator = StateCreator<
  DebateStore,
  [["zustand/immer", never]],
  [],
  VerdictSlice
>;

export const createVerdictSlice: VerdictSliceCreator = (set) => ({
  verdict: null,
  setVerdict: (v) => {
    set((state) => {
      state.verdict = v;
    });
  },
  clearVerdict: () => {
    set((state) => {
      state.verdict = null;
    });
  },
});
